<template>
    <div id="map" class="row map google-map"></div>
</template>

<script>

    let GoogleMapsLoader = require('google-maps');

    export default {
        props: ['locations', 'icon', 'apiKey'],

        created() {
            GoogleMapsLoader.KEY = this.apiKey;
            GoogleMapsLoader.VERSION = '3.36'
            GoogleMapsLoader.load(() => {
                this.loaded = true
                if (this.map === null) {
                    this.map = this.drawMap();
                }
                this.removeMarkers();
                this.addlocations(this.map, this.locations);
            });
        },

        data() {
            return {
                loaded: false,
                map: null,
                markers: [],
            }
        },
        watch: {
            locations: function (locations) {
                if (this.loaded) {
                    if (this.map === null) {
                        this.map = this.drawMap();
                    }
                    this.removeMarkers();
                    this.addlocations(this.map, locations);
                }
            },
        },
        methods: {
            drawMap: function () {
                const element = document.getElementById('map');
                const options = {
                    zoom: 14,
                    navigationControl: false,
                    mapTypeControl: false,
                    draggable: true,
                    zoomControl: true,
                    scaleControl: false,
                    scrollwheel: false,
                    disableDoubleClickZoom: true,
                    center: new google.maps.LatLng(38.695514, -90.419019),
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                return new google.maps.Map(element, options);
            },
            removeMarkers() {
                this.markers.forEach(function (marker) {
                    marker.setMap(null);
                });
                this.markers = [];
            },
            addlocations: function (map, locations) {
                const bounds = new google.maps.LatLngBounds();

                locations.forEach(location => {
                    const position = new google.maps.LatLng(location.latitude, location.longitude);

                    const marker = new google.maps.Marker({
                        position,
                        map,
                        title: location.city + ', ' + location.state,
                        icon: this.icon,
                    });

                    this.markers.push(marker);

                    const infowindow = new google.maps.InfoWindow();
                    const infoWindowText = this.generateInfoWindowText(location);

                    google.maps.event.addListener(marker, 'click', (function (marker, infoWindowText, infowindow) {
                        return function () {
                            infowindow.setContent(infoWindowText);
                            infowindow.open(map, marker);
                        };
                    })(marker, infoWindowText, infowindow));

                    map.fitBounds(bounds.extend(position));
                });

                var listener = google.maps.event.addListener(map, "idle", function () {
                    if (map.getZoom() > 16) map.setZoom(16);
                    google.maps.event.removeListener(listener);
                });

            },
            generateInfoWindowText: function (location) {
                return `
                    <div id="content">
                        <div id="siteNotice"></div>
                        <h1 id="firstHeading" class="firstHeading">${ location.name }</h1>
                        <div id="bodyContent">
                            <p>
                                <span class="mapstorename"> ${ location.address }  ${ location.city }, ${ location.state }  ${ location.zipcode }<br/>
                                <a href="tel:${ location.stripped_phone }">${ location.phone_number }</a> <br/>
                                <a href="${ location.store_page }" target="_blank">View Store Page</a> <br/>
                                <a href="${ location.directions_link }" target="_blank">Driving Directions</a>
                            </p>
                        </div>
                    </div>
                `;
            }
        }
    }

</script>
